<!--
 * @Author: your name
 * @Date: 2020-10-14 16:38:14
 * @LastEditTime: 2020-12-29 20:15:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/venue-home/component/TermsPrivacy/index.vue
-->
<style scoped lang="sass">
.terms_privacy
  display: flex
  flex-direction: column
  align-items: center

  .terms
    font-size: 12px
    line-height: 12px
    margin-bottom: 10px
    color: var(--menu-primary-text-colour)
    z-index: 1

  .privacy
    font-size: 12px
    line-height: 12px
    color: var(--menu-primary-text-colour)
    z-index: 1

  .power_by
    display: flex
    align-items: center
    margin: 10px 0

    .power
      height: 11px
      margin-right: 15px
      margin-top: 1px

    .mondomenu
      height: 32px

</style>

<template lang="pug">
.terms_privacy
  .terms.o7.p(@click="terms") {{ t('terms_of_use', 'Terms of Use') }}
  .privacy.o7.p(@click="privacy") {{ t('privacy_statement', 'Privacy Statement') }}
  .power_by
    img.power(src="@/assets/venueHomePic/power-by.png")
    img.mondomenu(src="@/assets/venueHomePic/mondomenu.png")
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { t } from '@/utils/language'

@Component({
  props: {
    showTermsDialog: Boolean,
    showPrivacyDialog: Boolean
  }
})
class TermsPrivacy extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  terms() {
    console.log('term')
    this.$emit('update:showTermsDialog', true)
  }

  privacy() {
    console.log('privacy')
    this.$emit('update:showPrivacyDialog', true)
  }
}

export default TermsPrivacy
</script>
